import { Column } from '../models/column';
import { SmallSection } from '../services';

/**
 * Get the section based on the given columnId
 * @param columnId number
 * @param sections SmallSection[]
 * @param columns { [key: string]: Column }
 * @returns SmallSection
 */
export const findSectionByColumnId = (
  columnId: number,
  sections: SmallSection[],
  columns: { [key: string]: Column }
) => {
  let columnForSearch: Column = columns[columnId];
  const columnsArray = Object.values(columns);

  let section = _findSectionByColumnId(sections, columnForSearch.columnId);
  if (section != null) return section;

  /**
   * If section is not found then assume column can be either a UOM column or a relatedColumn
   * so try to find either in unit or related columns
   */
  columnForSearch = columnsArray.find(column => {
    return column.unit?.columnId == columnId || column.getRelatedColumns()?.some(rc => rc.columnId === columnId);
  });

  // return if no column was found to perform the search
  if (columnForSearch == null) return null;

  return _findSectionByColumnId(sections, columnForSearch.columnId);
};

/**
 * Given a list of `sections` return the one that contains the given `columnId`
 * @param sections
 * @param columnId
 * @returns
 */
const _findSectionByColumnId = (sections: SmallSection[], columnId: number) =>
  sections.find(section => section.columns.some((column: number) => column === columnId));
